
export const AUTHENTICATION_REQUIRED_HEADER_NAME = 'x-authentication-required'
export const AUTHENTICATION_REQUIRED_HEADER = {'x-authentication-required' : true}


